import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import styles from "./thumbnailSlider.module.css";
import { getImageUrl } from "../../../lib/get-image";

const ThumbnailSlider = ({ bannersData }) => {
  return (
    <Swiper
      spaceBetween={10}
      slidesPerView={1}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{ clickable: true }}
      lazy={true}
      modules={[Autoplay, Pagination, Navigation]}
      className={styles.mainslider}
    >
      {bannersData?.map((item, index) => {
        const bannerJson = item?.json ? JSON.parse(item.json) : item;

        const imagePath = bannerJson?.image_url;

        // TEMPORARY DEBUG
        console.log("Banner image path:", imagePath);
        console.log("Final image URL:", getImageUrl(imagePath));

        return (
          <SwiperSlide key={bannerJson?.id || index}>
            <div className={styles.slide__container}>
              <img
                src={getImageUrl(imagePath)}
                alt={bannerJson?.banner_title || "Banner"}
                className={styles.slide_image}
                onError={(e) => {
                  console.error(
                    "IMAGE FAILED:",
                    e.currentTarget.src
                  );
                }}
                onLoad={(e) => {
                  console.log(
                    "IMAGE LOADED:",
                    e.currentTarget.src
                  );
                }}
              />
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default ThumbnailSlider;